<template>
  <div id="login">
    <img src="/static/img/logo_sima_100_full.png" class="center-block logo-login">

    <div class="text-center col-sm-12">
      <!-- login form -->
      <form @submit.prevent="checkCreds">
        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
          <input class="form-control" name="username" placeholder="Usuario" type="text" v-model="username">
        </div>

        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-lock"></i></span>
          <input class="form-control" name="password" placeholder="Password" type="password" v-model="password">
        </div>
        <button type="submit" v-bind:class="'btn btn-danger btn-lg'">Entrar <div v-if="this.loading=='1'" class="loading"></div></button>
      </form>

      <!-- errors -->
      <div v-if=response class="text-red"><p class="vertical-5p lead">{{response}}</p></div>
    </div>
  </div>
</template>

<script>
// import api from '../api'
import axios from 'axios'

export default {
    name: 'Login',
    data(router) {
        return {
            section: 'Login',
            loading: '',
            username: '',
            password: '',
            response: '',
            productoDB: null,
            token: null
        }
    },
    methods: {
    checkCreds() {
        const { username, password } = this
        
        this.toggleLoading()
        this.resetResponse()
        this.$store.commit('TOGGLE_LOADING')
        var vm = this
        axios.post('https://data.sima-api.com/auth/local', {
        	identifier: username,
        	password: password
        }).then(function (response) {
        	vm.token = response.data.jwt
        	if (response.data.user.role.name !== 'Shale' && response.data.user.role.name !== 'Administrator' && response.data.user.role.name !== 'Auditor' && 
                response.data.user.role.name !== 'Coordinador' && response.data.user.role.name !== 'Jefe de Obras' && response.data.user.role.name !== 'Project Manager') {
        		vm.toggleLoading()
            	vm.response = 'No esta autorizado para ingresar.'
				return false
        	}
        	if (response.data.user.blocked.name === 'true') {
            	vm.toggleLoading()
               	vm.response = 'No esta autorizado para ingresar.'
    			return false
            }
			vm.$store.commit('SET_USER', response.data.user.username)
            vm.$store.commit('SET_TOKEN', vm.token)

            if (window.localStorage) {
              window.localStorage.setItem('user', JSON.stringify(response.data.user))
              window.localStorage.setItem('token', vm.token)
            }

        	vm.$store.commit('CLEAR_ETIQUETAS', null)
        	vm.$store.commit('CLEAR_PRODUCTOS', null)
       
       		/* TRAIGO LAS ETIQUETAS */
        	axios.get('https://data.sima-api.com/shaleetiquetas', {headers: {
    		    	Authorization: 'Bearer ' + vm.token
    		 	}
    		})
    		.then(function (response) {
        		for (var i = 0; i < response.data.length; i++) {
					if (!response.data[i].Archivar) {
    					vm.$store.commit('ADD_ETIQUETA', response.data[i])
					}
    			}

        		/* TRAIGO LOS PRODUCTOS */
            	axios.get('https://data.sima-api.com/shaleproductos', {headers: {
        		    	Authorization: 'Bearer ' + vm.token
    				}
        		})
        		.then(function (response) {
        			for (var i = 0; i < response.data.length; i++) {
        				if (!response.data[i].Archivar) {
        					vm.$store.commit('ADD_PRODUCTO', response.data[i])
        				}
        			}
        			vm.toggleLoading()
                	vm.$router.push('/movimientos')
                }).catch(function (error) {
                	vm.toggleLoading()
                	vm.response = 'Se produjo un error al recuperar los productos. Por favor volve a intentarlo.'
                    console.log(error)
                })
            }).catch(function (error) {
                console.log(error)
            })
        }).catch(function (error) {
            console.log(error)
            vm.toggleLoading()
            vm.response = 'Usuario/Password incorrectos. Por favor volve a intentarlo.'
        })
    },
    toggleLoading() {
      this.loading = this.loading === '' ? '1' : ''
    },
    resetResponse() {
      this.response = ''
    }
    }
}
</script>

<style>
#login {
  padding: 10em;
}

html,
body,
.container-table {
  height: 100%;
  background-color: #282b30 !important;
}
.container-table {
  display: table;
  color: white;
}
.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.vertical-5p {
  padding-top: 5%;
}
.logo-login {
  padding: 3em;
  max-width: 460px;
}

.input-group {
  padding-bottom: 2em;
  height: 4em;
  width: 100%;
}

.input-group span.input-group-addon {
  width: 2em;
  height: 4em;
}

@media (max-width: 1241px) {
  .input-group input {
    height: 4em;
  }
}
@media (min-width: 1242px) {
  form {
    padding-left: 20em;
    padding-right: 20em;
  }

  .input-group input {
    height: 6em;
  }
}

.input-group-addon i {
  height: 15px;
  width: 15px;
}

.loading {
    border: 2px solid #f3f3f3;
    border-top: 2px solid #3498db;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    animation: spin 2s linear infinite;
    float: right;
    margin-left: 9px;
    margin-top: 4px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// Login.vue?69b7c821